import React from 'react'
import { ReactComponent as YoutubeIcon } from './youtube.svg'
export default function Youtube() {
  return <YoutubeIcon></YoutubeIcon>
}
